// extracted by mini-css-extract-plugin
export default {"toastSuccess":"style_toastSuccess__j3PIj","toastError":"style_toastError__JcCNm"};